export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const SHOW_NOTIFICATION_COMPLETE = 'SHOW_NOTIFICATION_COMPLETE';